import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import './index.scss'
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {message, Modal,Button, Descriptions, Upload, Progress} from "antd";
import {getStorage} from "@/utils";
import upload from '@/assets/images/upload.png'
import Axios from "axios";
import {getuploadfileparams, removepic} from "../../../../servers/menu";
import {
  refreshMenu,
} from "../../../../redux/common/action";
import {getbaseInfo, saveitemdata} from "../../../../servers/menuAPI";
import CInput from "../../../../components/CForm/CInput";
import store from "../../../../redux";
const axios = Axios.create();
@CBaseComponent
class Legal extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.inputChange = this.inputChange.bind(this)
    this.removeFile = this.removeFile.bind(this);
    this.beforeUpload1 = this.beforeUpload1.bind(this);
    this.confirmModal1 = this.confirmModal1.bind(this)
  }

  state = {
    data:{},
    museumid:'',
    meseum:false,
    progress:0,
    uploads: {
      action:'#',
      accept: '.jpg,.jpeg,.png,.gif',
      disabled: false,
      name: 'file',
      showUploadList: false,
      defaultFileList: [],//{uid: '', name: '', url: ''}
      fileList: [],
      limit: 5,//限制上传数量 默认无限制
      size: 1024*1024*10,//默认限制大小为2M
    }
  }

  inputChange(type,value){
    value = encodeURIComponent(value)
    this.setState({
      data:{...this.state.data,[type]: value}
    })
  }
  onSelect(){
    const params = {
      mimid:this.state.museumid
    }
    getbaseInfo(params).then(res=>{
      if (res.statecode === 0) {
        const result = res.records[7]
        this.setState({
          data:result
        })
      } else {
        message.error('未查询到博物馆信息');
      }
    })
  }


  onSubmit(){
    Modal.confirm({
      content: '确认保存数据',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.onSubmitHandler()
      }
    })
  }

  // 上传之前的判断
  async beforeUpload1(file,data){
    if (this.state.data.files.length === 5) {
      message.info('最多可上传5张图片');
      return false;
    }
    let name = file.name;
    let size = file.size;
    let currentFileType = name.split('.').pop();
    console.log(size);
    if(1*1024*1024>size || size > 10*1024*1024){
      message.info('请上传图片大小在1M到10M之间');
      return false;
    }
    if(currentFileType === 'png' || currentFileType === 'PNG' || currentFileType === 'JPG' || currentFileType === 'JPEG' || currentFileType === 'jpg' || currentFileType === 'jpeg'){
      let params = {}
      params = {
        type:this.state.data.type,
        dataid:this.state.data.dataid,
        fname:name
      }
      await getuploadfileparams(params).then(res=>{
        if(res.statecode === 0) {
          let formdata = new FormData()
          formdata.append('name', file.name)
          formdata.append('key', res.records[0].key)
          formdata.append('policy', res.records[0].policy)
          formdata.append('OSSAccessKeyId', res.records[0].OSSAccessKeyId)
          formdata.append('success_action_status', res.records[0].success_action_status)
          formdata.append('callback', res.records[0].callback)
          formdata.append('signature', res.records[0].signature)
          formdata.append('x:refid', res.records[0]['x:refid'])
          formdata.append('file', file)
          axios.post(
              res.records[0].host,
              formdata,
              {
                headers:
                    { 'Content-Type': 'multipart/form-data' },
                onUploadProgress:(progressEvent)=>{
                  let processStatu = (((progressEvent.loaded / progressEvent.total) * 100) | 0) ;
                  this.setState({
                    progress:processStatu
                  })
                }
              }
          )
              .then(res => {
                if (res.status === 200 && res.data.statecode === 0) {
                  message.success('上传成功')
                  const file = this.state.data.files
                  file.push(res.data.records[0])
                  this.setState({
                    data:{...this.state.data,files:file},
                    progress:0,
                  },()=>{
                    // this.onSelect()
                  })
                } else {
                  message.error('上传失败')
                  this.setState({
                    progress:0,
                  })
                }
              })
              .catch(error => {
                message.error('上传失败')
                this.setState({
                  progress:0,
                })
              })
        } else {
          message.info(res.statemessage);
        }
      })
      return false;
    }else{
      message.info('请上传图片');
    }
  }

  confirmModal1 = (fileid,index) => {
    const params = {
      fileid:fileid
    }
    removepic(params).then(res=>{
      if (res.statecode === 0) {
        message.success('移除成功')
        const data = this.state.data.files
        data.splice(index,1)
        this.setState({
          data:{...this.state.data,files:data}
        })
      } else {
        message.error(res.statemessage)
      }
    })
  };

  // 移出文件
  removeFile(id,index){
    Modal.confirm({
      content: '确认移除该图片',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.confirmModal1(id,index)
      }
    });
  }


  handlePreview(file){
    window.open(file,'_blank')
  }

  downloads(file){
    window.open(file,'_blank')
  }

  onSubmitHandler(type=''){
    saveitemdata(this.state.data).then(res=>{
      if(res.statecode === 0) {
        message.success('保存成功');
      } else {
        message.error(res.statemessage);
      }
    })
  }

  componentDidMount(){
    const data = getStorage('userList')
    if (data.clerklevel != 8) {
      const museumid = store.getState().libraryid
      this.setState({
        museumid:museumid,
        meseum:true
      },()=>{
        this.onSelect()
      })
    } else {
      this.setState({
        museumid:data.miid+data.museumid,
      },()=>{
        this.onSelect()
      })
    }
  }

  render(){
    return (
        <div
            className={this.state.meseum ? 'store-manage-list-new base-info  base-infodisabled' : 'store-manage-list-new base-info'}>
          <div className='base-title'>
            <div>
              <span className='title-before-icon'></span>
              <span className='title'>创新项六</span>
            </div>
          </div>
          {
            this.state.data.tips ?
                <div>
                  <div className='shenhe-item shenhe-itemnew'>
                    <div className='shenhe-itemintro'>
                      <span>{decodeURIComponent(this.state.data.tips)}</span>
                    </div>
                    <CInput placeholder="请输入内容" type='textarea' disabled={this.state.meseum}
                            value={decodeURIComponent(this.state.data.content)} onChange={(value) => {
                      this.inputChange('content', value)
                    }}/>
                  </div>
                  <div className='shenhe-item' style={{marginTop: '20px'}}>
                    {
                      (!this.state.meseum || this.state.data.files.length>0)? <span style={{width:'80px'}}>展示图片: </span>:''
                    }
                    {
                      this.state.meseum ? '' :
                          <span style={{color: 'red',marginLeft:'10px'}}>只能上传图片，图片大小在1M至10M之间，最多可上传5张图片。</span>

                    }
                  </div>
                  <div className='shenhe-item shenhe-itemblock' style={{marginTop: '-10px'}}>
                    <div style={{width: '100%'}}>
                      {
                        this.state.meseum ? '' :
                            <div
                                style={{display: 'flex', justifyItems: 'flex-end', flexDirection: 'column', marginTop: '20px'}}>
                              <Upload
                                  {...this.state.uploads}
                                  beforeUpload={(file, fileList) => this.beforeUpload1(file)}
                                  onRemove={(file) => this.removeFile1(file)}
                              >
                                <div><Button type='primary'><img src={upload} alt="" style={{width: '20px'}}/>上传文件</Button>
                                </div>
                              </Upload>
                              {this.state.progress > 0 ?
                                  <Progress percent={this.state.progress}/> : ''
                              }
                            </div>
                      }
                      {this.state.data.files && this.state.data.files.map((item, index) => {
                        return (
                            <Descriptions column={{xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1}} bordered
                                          style={{marginTop: '20px'}}>
                              <Descriptions.Item label="文件名称"
                                                 style={{textAlign: 'center'}}>{item.filename}</Descriptions.Item>
                              <Descriptions.Item label="操作">
                                <Button type="link" onClick={() => {
                                  this.handlePreview(item.filepreviewurl)
                                }}>预览</Button>
                                <Button type="link" onClick={() => {
                                  this.downloads(item.fileurl)
                                }} style={{marginLeft: '-20px'}}>下载</Button>
                                { !this.state.meseum
                                    && <Button type="link" onClick={() => {
                                      this.removeFile(item.fileid,index)
                                    }} style={{color: 'red', marginLeft: '-20px'}}>删除</Button>
                                }
                              </Descriptions.Item>
                            </Descriptions>
                        )
                      })}
                    </div>
                  </div>
                </div>
                :''
          }
          {!this.state.meseum &&
              <div style={{display:'flex',width:'100%',justifyContent:'center',marginTop:'20px'}}>
                <Button type="primary" onClick={() => {
                  this.onSubmit()
                }}>保存</Button>
              </div>
          }
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Legal);

